export default __webpack_public_path__ + "static/media/time.18c90110.svg";